'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Capability(icon, title, text, area) {
  this.gB = null;
  this.gD = null;
  this.gC = null;
  this.gA = null;
  this.gB = icon;
  this.gD = title;
  this.gC = text;
  this.gA = area;
}
export { $c_Lio_intela_sites_intelacloud_content_Capability as $c_Lio_intela_sites_intelacloud_content_Capability };
$p = $c_Lio_intela_sites_intelacloud_content_Capability.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Capability;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Capability() {
}
export { $h_Lio_intela_sites_intelacloud_content_Capability as $h_Lio_intela_sites_intelacloud_content_Capability };
$h_Lio_intela_sites_intelacloud_content_Capability.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 1961550699, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Capability)) {
    var x = this.gB;
    var x$2 = x$0.gB;
    if ((((x === x$2) && (this.gD === x$0.gD)) && (this.gC === x$0.gC))) {
      return (this.gA === x$0.gA);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 4;
});
$p.I = (function() {
  return "Capability";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gB;
      break;
    }
    case 1: {
      return this.gD;
      break;
    }
    case 2: {
      return this.gC;
      break;
    }
    case 3: {
      return this.gA;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Capability(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bo)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Capability as $isArrayOf_Lio_intela_sites_intelacloud_content_Capability };
var $d_Lio_intela_sites_intelacloud_content_Capability = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Capability, "io.intela.sites.intelacloud.content.Capability", ({
  bo: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Capability as $d_Lio_intela_sites_intelacloud_content_Capability };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Capability.js.map
